import { FunctionComponent } from 'react';
import SVG from 'react-inlinesvg';

export const TeamMapAnimation: FunctionComponent = () => {
  return (
    <SVG
      className="team-map"
      type="image/svg+xml"
      src={require('../../../public/img/team_map.svg')?.default?.src}
    />
  );
};
